import React from 'react';
import {
  FiClock,
  FiCoffee,
  FiUsers,
  FiTarget,
  FiShield,
  FiArrowUp,
  FiArrowDown,
} from 'react-icons/fi';
import styles from '../DashboardOverviewNew.module.scss';

const ICON_MAP = {
  clock: FiClock,
  coffee: FiCoffee,
  users: FiUsers,
  target: FiTarget,
  shield: FiShield,
};

export const KeyHighlights = ({ data, isLoading = false }) => (
  <div
    className={styles.highlightsSection}
    style={isLoading ? { opacity: 0.5, pointerEvents: 'none' } : undefined}
  >
    <span className={styles.cardTitle}>Key Highlights</span>

    <div className={styles.highlightsRow}>
      {data.map((item) => {
        const Icon = ICON_MAP[item.iconType] || FiClock;
        return (
          <div key={item.id} className={styles.highlightItem}>
            <div className={styles.highlightItemHeader}>
              <div
                className={styles.highlightIconWrapper}
                style={{ backgroundColor: item.iconBg }}
              >
                <Icon size={17} color={item.iconColor} />
              </div>
              <span className={styles.highlightLabel}>{item.label}</span>
            </div>

            <div className={styles.highlightValueRow}>
              <span className={styles.highlightValue}>{item.value}</span>
              {item.trendPct !== 0 && (
                <span
                  className={`${styles.highlightTrend} ${
                    item.trendUp ? styles.trendUp : styles.trendDown
                  }`}
                >
                  {item.trendUp ? (
                    <FiArrowUp size={10} />
                  ) : (
                    <FiArrowDown size={10} />
                  )}
                  {item.trendPct}
                  {item.trendUnit}
                </span>
              )}
            </div>

            {item.sublabelLink ? (
              <span className={styles.highlightSublabelLink}>
                {item.sublabel}
              </span>
            ) : (
              <span className={styles.highlightSublabel}>
                <span style={{ color: item.iconColor }}>{item.sublabel}</span>
                {item.sublabelSuffix && (
                  <span className={styles.highlightSublabelSuffix}>
                    {' '}
                    {item.sublabelSuffix}
                  </span>
                )}
              </span>
            )}
          </div>
        );
      })}
    </div>
  </div>
);
